import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const pad = (n) => String(n).padStart(2, '0');
const toYmd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// Minimal homework / notice sender. Uses the existing /api/classwork and /api/announcements routes.
function TeacherDispatchCard({ user, cls, initialKind = 'homework' }) {
  const [kind, setKind] = useState(initialKind);
  const [subject, setSubject] = useState(user.subject || '');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [note, setNote] = useState({ ok: true, text: '' });

  const send = async (e) => {
    e.preventDefault();
    if (!message.trim() || (kind === 'homework' && !subject.trim())) {
      setNote({ ok: false, text: kind === 'homework' ? 'Enter subject and message.' : 'Enter a message.' });
      return;
    }
    setSending(true);
    setNote({ ok: true, text: '' });
    try {
      if (kind === 'homework') {
        await axios.post(`${API_BASE_URL}/api/classwork`, {
          teacherId: user.id, class: cls, date: toYmd(new Date()),
          type: 'homework', subject: subject.trim(), message: message.trim()
        });
      } else {
        await axios.post(`${API_BASE_URL}/api/announcements`, {
          title: 'Class Notice', message: message.trim(), type: 'class', class: cls, createdBy: user.name
        });
      }
      setMessage('');
      setNote({ ok: true, text: `Sent to Class ${cls} ✓` });
    } catch (err) {
      setNote({ ok: false, text: 'Could not send. Check your connection and try again.' });
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="th-card">
      <div className="th-card-head"><h2>Homework &amp; Notice</h2></div>
      <form onSubmit={send}>
        <div className="th-seg">
          <button type="button" className={kind === 'homework' ? 'on' : ''} onClick={() => setKind('homework')}>Homework</button>
          <button type="button" className={kind === 'notice' ? 'on' : ''} onClick={() => setKind('notice')}>Notice</button>
        </div>
        {kind === 'homework' && (
          <input className="th-input" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Subject" />
        )}
        <textarea className="th-input" rows={3} value={message} onChange={(e) => setMessage(e.target.value)}
          placeholder={kind === 'homework' ? 'Type today’s homework…' : 'Type the notice…'} />
        {note.text && <div className={note.ok ? 'th-okmsg' : 'th-error'}>{note.text}</div>}
        <button className="th-btn th-btn-block" type="submit" disabled={sending || !cls}>
          {sending ? 'Sending…' : 'Send to Students'}
        </button>
      </form>
    </section>
  );
}

export default TeacherDispatchCard;
